import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { WellPadPreparationPadsList } from 'src/features/well-pad-preparation-pads-list';
import { useStore } from 'src/store';

import { WellPadPreparationSubheader } from './components';
import { WellPadPreparationStoreContext } from './use-pad-preparation-store';
import { WellPadPreparationStore } from './well-pad-preparation.store';

import styles from './well-pad-preparation.module.scss';

export const WellPadPreparation = observer(function WellPadPreparation() {
  const { wellPadPreparation, planVersionsService, directories } = useStore();
  const [wellPadPreparationStore] = useState(
    () => new WellPadPreparationStore(directories, planVersionsService, wellPadPreparation),
  );

  useEffect(() => {
    return wellPadPreparation.init();
  }, [wellPadPreparation]);

  return (
    <WellPadPreparationStoreContext.Provider value={{ wellPadPreparationStore }}>
      <div className={styles.mainContentWrapper}>
        <WellPadPreparationSubheader />

        <div className={styles.tableContainer}>
          <WellPadPreparationPadsList />
        </div>
      </div>
    </WellPadPreparationStoreContext.Provider>
  );
});
